<template>
	<div>
		<h1>Output</h1>

		<p>
			<b>Select sections to include in output</b>
		</p>
		<div style="text-align: center;">
			<Button label="Select All" @click="selectAll()" class="p-mr-2 p-mb-2 btsyleblue" />
			<Button label="Deselect All" @click="deselectAll()" class="p-mr-2 p-mb-2 btsyleblue" />
		</div>
		<div v-for="(option, index) of outputOptions" :key="index" class="p-field-checkbox">
			<Checkbox :id="index" :binary="true" v-model="option.include" :disabled="option.disabled" />
			<label :for="index">{{ option.label }}</label>
		</div>

		<div class="p-mt-3 p-d-flex p-jc-center">
			<Button class="btsyleblue" label="Generate Output" @click="openModal()" />
		</div>

		<!-- Modal to display output -->
		<Dialog header="Trial Protocol" :visible.sync="displayModal" :baseZIndex="2000" :modal="true">
			<!-- :style="{ width: '80vw' }" -->
			<div id="output">
				<!-- <div v-for="output in selectedOutputs" :key="output.data">
					<h3>{{ output.label }}</h3>
					<component :is="output.outputComponent.name" :data="getData(output.data)" :key="output.key" />
				</div> -->
				<h2>Study Setting</h2>
				<OutputStudySetting v-if="outputOptions[0].include" :key="monitorChange" />
				<h2>Eligibility Criteria</h2>
				<OutputEligibilityCriteria v-if="outputOptions[1].include" :key="monitorChange + 1" />
				<h2>Interventions</h2>
				<OutputInterventions v-if="outputOptions[2].include" :key="monitorChange + 2" />
				<h2>Outcomes</h2>
				<OutputOutcomes v-if="outputOptions[3].include" :key="monitorChange + 3" :showAppendix="false" />
				<h3>Participant Timeline</h3>
				<OutputParticipantTimeline v-if="outputOptions[4].include" :key="monitorChange + 4" />
				<h3>Sample Size</h3>
				<OutputSampleSize v-if="outputOptions[5].include" :key="monitorChange + 5" />
				<h2>Recruitment</h2>
				<OutputRecruitment v-if="outputOptions[6].include" :key="monitorChange + 6" />
				<h2>Assignment of Interventions</h2>
				<OutputAssignmentOfInterventions v-if="outputOptions[7].include" :key="monitorChange + 7" />
				<h2>Data Collection, Management and Analysis</h2>
				<OutputDataCollection v-if="outputOptions[8].include" :key="monitorChange + 8" />
				<h2>Monitoring</h2>
				<OutputMonitoring v-if="outputOptions[9].include" :key="monitorChange + 9" />
				<h2>Ethics and Consent</h2>
				<OutputEthicsAndConsent v-if="outputOptions[10].include" :key="monitorChange + 10" />
				<h2>Dissemination</h2>
				<OutputDissemination v-if="outputOptions[11].include" :key="monitorChange + 11" />
				<h2>Study Information</h2>
				<OutputStudyInformation v-if="outputOptions[12].include" :key="monitorChange + 12" />
				<h2>Contributions</h2>
				<OutputTrialContributions v-if="outputOptions[13].include" :key="monitorChange + 13" />
				<!-- <h2>Eligibility Criteria</h2>
				<h3>Study Setting</h3>
				<OutputStudySetting :data="studySetting" />
				<h3>Eligibility Criteria</h3>
				<OutputEligibilityCriteria :data="eligibilityCriteria" />
				<h3>Interventions</h3>
				<OutputInterventions :data="interventions" />
				<h3>Outcomes</h3>
				<OutputOutcomes :data="outcomes" />
				<h3>Participant Timeline</h3>
				<OutputParticipantTimeline :data="participantTimeline" />
				<h3>Sample Size</h3>
				<OutputOutcomes :data="sampleSize" />
				<h3>Recruitment</h3>
				<OutputOutcomes :data="recruitment" />
				<h3>Assignment of Interventions</h3>
				<OutputOutcomes :data="assignmentOfInterventions" />
				<h3>Data Collection, Management, and Analysis</h3>
				<OutputOutcomes :data="dataCollection" />
				<h3>Monitoring</h3>
				<OutputOutcomes :data="monitoring" />
				<h3>Ethics and Dissemination</h3>
				<OutputOutcomes :data="ethicsAndDissemination" /> -->
			</div>
			<template #footer>
				<Button class="btsyleblue" label="Copy Methods to Clipboard" @click="copy" />
				<Button class="btsyleblue" label="Rewrite Methods" @click="reload" />
			</template>
		</Dialog>
	</div>
</template>

<script>
import CopyMixin from "@/mixins/CopyMixin.js";
// import deepstreamMixin from "@/mixins/DeepstreamMixin";

import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";

import OutputStudySetting from "./OutputStudySetting.vue";
import OutputEligibilityCriteria from "./OutputEligibilityCriteria.vue";
import OutputInterventions from "./OutputInterventions.vue";
import OutputOutcomes from "./OutputOutcomes.vue";
import OutputParticipantTimeline from "./OutputParticipantTimeline.vue";
import OutputSampleSize from "./OutputSampleSize.vue";
import OutputRecruitment from "./OutputRecruitment.vue";
import OutputAssignmentOfInterventions from "./OutputAssignmentOfInterventions.vue";
import OutputDataCollection from "./OutputDataCollection.vue";
import OutputMonitoring from "./OutputMonitoring.vue";
// import OutputEthicsAndDissemination from "./OutputEthicsAndDissemination.vue";
import OutputStudyInformation from "./OutputStudyInformation.vue";
import OutputEthicsAndConsent from "./OutputEthicsAndConsent.vue";
import OutputDissemination from "./OutputDissemination.vue";
import OutputTrialContributions from "../methods-wizard/OutputContributions.vue";

export default {
	name: "ViewOutput",
	mixins: [
		CopyMixin,
		// deepstreamMixin("studyInformation"),
		// deepstreamMixin("studySetting"),
		// deepstreamMixin("eligibilityCriteria"),
		// deepstreamMixin("interventions"),
		// deepstreamMixin("outcomes"),
		// deepstreamMixin("participantTimeline"),
		// deepstreamMixin("sampleSize"),
		// deepstreamMixin("recruitment"),
		// deepstreamMixin("assignmentOfInterventions"),
		// deepstreamMixin("dataCollection"),
		// deepstreamMixin("monitoring"),
		// // deepstreamMixin("ethicsAndDissemination"),
		// deepstreamMixin("ethicsAndConsent"),
		// deepstreamMixin("dissemination"),
		// deepstreamMixin("studyInformation")
	],
	components: {
		Button,
		Dialog,
		Checkbox,
		OutputStudySetting,
		OutputEligibilityCriteria,
		OutputInterventions,
		OutputOutcomes,
		OutputParticipantTimeline,
		OutputSampleSize,
		OutputRecruitment,
		OutputAssignmentOfInterventions,
		OutputDataCollection,
		OutputMonitoring,
		// OutputEthicsAndDissemination,
		OutputStudyInformation,
		OutputEthicsAndConsent,
		OutputDissemination,
		OutputTrialContributions
	},
	computed: {
		selectedOutputs() {
			return this.outputOptions.filter(option => option.include);
		}
	},
	data() {
		return {
			monitorChange: 0,
			outputOptions1: [
				{
					label: "Study Setting",
					outputComponent: OutputStudySetting,
					data: "studySetting",
					include: true
				},
				{
					label: "Eligibility Criteria",
					outputComponent: OutputEligibilityCriteria,
					data: "eligibilityCriteria",
					include: true
				},
				{
					label: "Interventions",
					outputComponent: OutputInterventions,
					data: "interventions",
					include: true
				},
				{
					label: "Outcomes",
					outputComponent: OutputOutcomes,
					data: "outcomes",
					include: true
				},
				{
					label: "Participant Timeline",
					outputComponent: OutputParticipantTimeline,
					data: "participantTimeline",
					include: true
				},
				{
					label: "Sample Size",
					outputComponent: OutputSampleSize,
					data: "sampleSize",
					include: true
				},
				{
					label: "Recruitment",
					outputComponent: OutputRecruitment,
					data: "recruitment",
					include: true
				},
				{
					label: "Assignment of Interventions",
					outputComponent: OutputAssignmentOfInterventions,
					data: "assignmentOfInterventions",
					include: true
				},
				{
					label: "Data Collection, Management and Analysis",
					outputComponent: OutputDataCollection,
					data: "dataCollection",
					include: true
				},
				{
					label: "Monitoring",
					outputComponent: OutputMonitoring,
					data: "monitoring",
					include: true
				},
				// {
				// 	label: "Ethics and Dissemination",
				// 	outputComponent: OutputEthicsAndDissemination,
				// 	data: "ethicsAndDissemination",
				// 	include: true
				// },
				{
					label: "Ethics and Consent",
					outputComponent: OutputEthicsAndConsent,
					data: "ethicsAndConsent",
					include: true
				},
				{
					label: "Dissemination",
					outputComponent: OutputDissemination,
					data: "dissemination",
					include: true
				},
				{
					label: "Study Information",
					outputComponent: OutputStudyInformation,
					data: "studyInformation",
					include: true
				},
				{
					label: "Contributions",
					outputComponent: OutputTrialContributions,
					data: "contributions",
					include: true
				}
			],
			outputOptions: [
				{ label: "Study Setting", include: true },
				{ label: "Eligibility Criteria", include: true },
				{ label: "Interventions", include: true },
				{ label: "Outcomes", include: true },
				{ label: "Participant Timeline", include: true },
				{ label: "Sample Size", include: true },
				{ label: "Recruitment", include: true },
				{ label: "Assignment of Interventions", include: true },
				{ label: "Data Collection, Management and Analysis", include: true },
				{ label: "Monitoring", include: true },
				{ label: "Ethics and Consent", include: true },
				{ label: "Dissemination", include: true },
				{ label: "Study Information", include: true },
				{ label: "Contributions", include: true },
			],
			selectedOptions: [],
			displayModal: false
		};
	},
	methods: {
		openModal() {
			this.displayModal = true;
		},
		closeModal() {
			this.displayModal = false;
		},
		getData(dataName) {
			return this[dataName];
		},
		selectAll() {
			this.outputOptions.forEach(option => (option.include = true));
		},
		deselectAll() {
			this.outputOptions.forEach(option => (option.include = false));
		},
		reload() {
			// alert(this.monitorChange);
			this.monitorChange = this.monitorChange + 1;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btsyleblue {
	margin: 10px;
	/* width: 100px; */
	background-color: #83bfed;
	border-radius: 20px;
	/* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px; */
	color: #05305f;
	cursor: pointer;
	display: inline-block;
	font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
	padding: 7px 20px;
	text-align: center;
	text-decoration: none;
	/* transition: all 250ms; */
	border: 0;
	font-size: 16px;
}
</style>
